import { FC } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import {
  editFormDataAF,
  EditFormMode,
  formTabControlsSF,
  ICourseDto,
} from "@ryde/shared";

import { FormControlsWrapper } from "../../form.controls.wrapper";
import { CourseStationsPanel } from "../stations";
import {
  CourseBasicTabInputs,
  CourseTabsTabStationsStyled,
} from "./course.styled";

export const CourseTabsTabStations: FC = () => {
  const { entity, mode } = useCrudEditContext<ICourseDto>();
  const currentTabControls = useRecoilValue(formTabControlsSF(entity));
  const courseDto = useRecoilValue(
    editFormDataAF([entity, mode || EditFormMode.CrudRoute]),
  ) as ICourseDto | undefined;
  return (
    <CourseTabsTabStationsStyled>
      <CourseBasicTabInputs>
        <FormControlsWrapper controls={currentTabControls} />
      </CourseBasicTabInputs>
      {courseDto && <CourseStationsPanel courseDto={courseDto} />}
    </CourseTabsTabStationsStyled>
  );
};
